import { apiPost } from '../api';
import { disablePush } from '../services/firebasePush';

/**
 * Shared website sign-out: unregister FCM, invalidate API session, clear local cache.
 * Safe to call from any logout button — each step is best-effort.
 */
export async function signOutWebsite(): Promise<void> {
  try {
    await disablePush();
  } catch {
    /* ignore */
  }

  try {
    await apiPost('/auth/logout', {});
  } catch {
    /* ignore */
  }

  localStorage.removeItem('srs_token');
  localStorage.removeItem('srs_user');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.dispatchEvent(new Event('userUpdated'));
}
